import React from 'react';
import PropTypes from 'prop-types';
import ListItem from '@mui/material/ListItem';
import Box from '@mui/material/Box';
import { Skeleton } from '@mui/material';

const NavSkeleton = ({ className }) => {
  return (
    <ListItem disablePadding className={className}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          paddingLeft: { xs: 2, md: 3 },
          paddingY: 1.5,
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          className="nav-icon-wrapper"
          sx={{ width: '24px', height: '24px', marginRight: 2 }}
        >
          <Skeleton
            variant="circular"
            width={24}
            height={24}
            sx={{ bgcolor: 'rgba(255, 255, 255, 0.1)' }}
          />
        </Box>
        <Skeleton
          variant="text"
          width={120}
          height={20}
          sx={{ bgcolor: 'rgba(255, 255, 255, 0.1)' }}
        />
      </Box>
    </ListItem>
  );
};

NavSkeleton.propTypes = {
  className: PropTypes.string,
};

export default NavSkeleton;
